module.exports = __webpack_public_path__ + "15-o1.jpg?08a22297059009716d10b93411c4aeb4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/15-o1.jpg
// module id = 628
// module chunks = 0